import axios from 'axios';
import {backendHost} from '../../config';

const postAuthorization = (params) => {
    return axios.post(`${backendHost}/api/admin/auth/authorization`, params);
};

export {
    postAuthorization
}